var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FontAwesomeIcon',_vm._b({class:_vm.classIcon,attrs:{"icon":[_vm.prefix, _vm.name],"fixed-width":"","size":"3x"}},'FontAwesomeIcon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }